export enum dateFormat {
  Month = 'dd-MM-yyyy',
  dateTime = 'dd/MM/yyyy, hh:mm a',
}

export enum yearDateFormat {
  date = 'YYYY-MM-DD',
  feedbackDate = 'YYYY-MM-DD - hh:mm A',
  label = 'MMMM, YYYY',
  value = 'M-YYYY',
  MonthYear = 'MMM yyyy',
}